import React from 'react';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';
import usePlayfulTeacher from '@/hooks/usePlayfulTeacher';
import ComplementaryActivityDefault from './Default';
import ComplementaryActivityPlayful from './Playful';
import ComplementaryActivityPlayfulTeacher from './PlayfulTeacher';

export function ComplementaryActivity(props) {
  const isPlayfulStudentTheme = usePlayfulStudent();
  const isPlayfulTeacherTheme = usePlayfulTeacher();

  if (isPlayfulStudentTheme) return <ComplementaryActivityPlayful {...props} />;
  if (isPlayfulTeacherTheme) return <ComplementaryActivityPlayfulTeacher {...props} />;
  return <ComplementaryActivityDefault {...props} />;
}
